const SI_PREFIXES = ['', 'k', 'M', 'B', 'T', 'P', 'E'];

export default function abbreviateNumber(number) {
  // what tier? (determines SI prefix)
  const tier = Math.log10(Math.abs(number)) / 3 | 0; // eslint-disable-line no-bitwise

  // if zero, we don't need a prefix
  if (tier === 0) return number;

  // get prefix and determine scale
  const prefix = SI_PREFIXES[tier];
  const scale = 10 ** (tier * 3);

  // scale the number
  const scaled = number / scale;
  let formatted = `${scaled.toFixed(1)}`;
  if (/\.0$/.test(formatted)) {
    formatted = formatted.substr(0, formatted.length - 2);
  }
  return formatted + prefix;
}



// WEBPACK FOOTER //
// ./src/util/abbreviateNumber.js